module.exports = __webpack_public_path__ + "static/DriedSourdough-9e35bce93c9774a24294d8abaafdaf79.webp";